import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppLayout } from "../../../layouts";
import {
    Buttton,
    CustomDatePicker,
    Header,
    Inputs,
    Modaal,
    NavAndTabs,
    SelectO,
    Sides,
} from "../../../components";
import { Col, Container, Row, Form } from "react-bootstrap";
import DefaultWorkingTime from "./defaultWorkingTime";
import CustomWorkingTime from "./customWorkingTime";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { IoTimeOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor } from "../../../redux/actions";
import { useAlert, useModal, useSnackBar, useToast } from "../../../contexts";
import { TbInfoTriangleFilled } from "react-icons/tb";


const options1 = [];
for (let i = 15; i <= 120; i += 15) {
    options1.push({ value: i, label: `${i} min` });
}

const MySchedule = ({ loginData }) => {
    const { t } = useTranslation();
    const options = [
        { value: 1, label: t("days.monday"), sortName: "Mon" },
        { value: 2, label: t("days.tuesday"), sortName: "Tue" },
        { value: 3, label: t("days.wednesday"), sortName: "Wed" },
        { value: 4, label: t("days.thursday"), sortName: "Thu" },
        { value: 5, label: t("days.friday"), sortName: "Fri" },
        { value: 6, label: t("days.Saturday"), sortName: "Sat" },
        { value: 7, label: t("days.Sunday"), sortName: "Sun" },
    ];
    const { id } = useParams();
    const { showModal, hideModal } = useModal();
    const { showAlert } = useAlert();
    const { showToast } = useToast();
    const { showSnackBar } = useSnackBar();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [credentials, setCredentials] = useState({
        doctorGuid: loginData.userGuid,
        clinicGuid: loginData.clinicGuid,
        defaultTimingGuid: '00000000-0000-0000-0000-000000000000',
        isOnlineAppointment: true,
        isClinicSchedule: false,
        timeSlot: null,
        days: [],
        workFromTime: null,
        workToTime: null,
        lunchFromTime: null,
        lunchToTime: null,
    });

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        if (!credentials.days || credentials.days.length === 0) {
            newErrors.days = "Please select at least one day.";
        }
        if (!credentials.timeSlot || isNaN(credentials.timeSlot) || credentials.timeSlot <= 0) {
            newErrors.timeSlot = "Enter a valid consultation time (positive number).";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const [credentials1, setCredentials1] = useState({
        doctorGuid: loginData.userGuid,
        clinicGuid: loginData.clinicGuid,
        customTimingGuid: null,
        isDayOff: false,
        appointmentType: 1,
        fromDate: "",
        toDate: "",
        workFromTime: null,
        workToTime: null,
        lunchFromTime: null,
        lunchToTime: null,
        isYearlyDayOff: false,
        isAnotherClinicSchedule: false,
    });



    const [errors1, setErrors1] = useState({});
    const validate1 = () => {
        const errors = {};

        // if (credentials1.workFromTime && credentials1.workToTime) {
        //     const workFrom = new Date(`1970-01-01T${credentials1.workFromTime}:00`);
        //     const workTo = new Date(`1970-01-01T${credentials1.workToTime}:00`);

        //     if (workFrom >= workTo) {
        //         errors.workFromTime = "Work start time cannot be later than work end time.";
        //     }
        // }
        if (!credentials1.fromDate) {
            errors.fromDate = "From Date is required.";
        }

        if (!credentials1.toDate) {
            errors.toDate = "To Date is required.";
        }

        setErrors1(errors);
    }

    useEffect(() => {
        dispatch(actionDoctor.getDefaultTiming(loginData.userGuid, loginData.clinicGuid, false));
        dispatch(actionDoctor.getCustomTiming(loginData.userGuid, "",));
    }, [dispatch, loginData]);


    const getDefaultTimingData = useSelector((state) => state.doctor.getDefaultTimingData?.data);
    const onlineAppointments = getDefaultTimingData?.result.filter(item => item.isOnlineAppointment === true);
    const offlineAppointments = getDefaultTimingData?.result.filter(item => item.isOnlineAppointment === false);

    const customAppointments = useSelector((state) => state.doctor.getCustomTimingData?.data?.result);

    const [showModal1, setShowModal1] = useState(false);
    const handleCloseModal = () => {
        setShowModal1(false);
        setSelectedSelectWeekDays([])
    };
    const [selectedSelectWeekDays, setSelectedSelectWeekDays] = useState([]);
    const [selectedSelectTimeSlot, setSelectedSelectTimeSlot] = useState([]);
    const [workTimeFrom, setWorkTimeFrom] = useState(null);
    const [workTimeTo, setWorkTimeTo] = useState(null);
    const [lunchTimeFrom, setLunchTimeFrom] = useState(null);
    const [lunchTimeTo, setLunchTimeTo] = useState(null);
    const [workDateFrom, setworkDateFrom] = useState(null);
    const [workDateTo, setworkDateTo] = useState(null);
    const [workTimeFrom1, setWorkTimeFrom1] = useState(null);
    const [workTimeTo1, setWorkTimeTo1] = useState(null);
    const [lunchTimeFrom1, setLunchTimeFrom1] = useState(null);
    const [lunchTimeTo1, setLunchTimeTo1] = useState(null);

    const handleSelectWeekDays = (name, selected) => {
        const value = selected
            ? Array.isArray(selected)
                ? selected.map((option) => option.value)
                : selected.value
            : "";
        setCredentials((prevCredentials) => ({
            ...prevCredentials,
            [name]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            days: "",
        }));
        setSelectedSelectWeekDays(selected);

    };
    const handleSelectTimeSlot = (selected) => {
        const value = selected
            ? Array.isArray(selected)
                ? selected.map((option) => option.value)
                : selected.value
            : null;


        setCredentials((prevCredentials) => ({
            ...prevCredentials,
            timeSlot: value,
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            timeSlot: value && value > 0 ? "" : prevErrors.timeSlot,
        }));
        setSelectedSelectTimeSlot(selected)

    };

    const handleTimeChange = (time, field) => {

        if (time) {
            const localTime = new Date(time.getTime() - time.getTimezoneOffset() * 60000);
            const formattedTime = localTime.toISOString().slice(0, -1);
            setCredentials((prevState) => ({
                ...prevState,
                [field]: formattedTime,
            }));

            // Update specific time state
            switch (field) {
                case "workFromTime":
                    setWorkTimeFrom(time);
                    break;
                case "workToTime":
                    setWorkTimeTo(time);
                    break;
                case "lunchFromTime":
                    setLunchTimeFrom(time);
                    break;
                case "lunchToTime":
                    setLunchTimeTo(time);
                    break;
                default:
                    break;
            }
        }
    };

    const handleTimeChange1 = (time, field) => {
        if (time) {
            const localTime = new Date(time.getTime() - time.getTimezoneOffset() * 60000);
            const formattedTime = localTime.toISOString().slice(0, -1);
            setCredentials1((prevState) => ({
                ...prevState,
                [field]: formattedTime,
            }));

            // Update specific time state
            switch (field) {
                case "workFromTime":
                    setWorkTimeFrom1(time);
                    break;
                case "workToTime":
                    setWorkTimeTo1(time);
                    break;
                case "lunchFromTime":
                    setLunchTimeFrom1(time);
                    break;
                case "lunchToTime":
                    setLunchTimeTo1(time);
                    break;
                default:
                    break;
            }
        }
    };

    const handleEditDefaultWorkingTime = (Appointment) => {
        const selectedDays = Appointment.days
            ? Appointment.days.map((day) =>
                options.find((option) => option.value === day)
            )
            : Appointment.dayID
                ? [options.find((option) => option.value === Appointment.dayID)]
                : [];

        const selectedDuration = Appointment.timeSlot




        const parseTime = (time) => (time ? new Date(time) : null);

        // setCredentials({
        //     doctorGuid: loginData.userGuid,
        //     clinicGuid: loginData.clinicGuid,

        // });

        setCredentials((prevCredentials) => ({
            ...prevCredentials,  // Spread the previous state to keep existing values
            defaultTimingGuid: Appointment.defaultTimingGuid,
            clinicGuid: Appointment.clinicGuid,
            isOnlineAppointment: Appointment.isOnlineAppointment,
            days: Appointment.days || (Appointment.dayID ? [Appointment.dayID] : []),
            workFromTime: Appointment.workFromTime,
            workToTime: Appointment.workToTime,
            lunchFromTime: Appointment.lunchFromTime,
            lunchToTime: Appointment.lunchToTime,
        }));

        setWorkTimeFrom(parseTime(Appointment.workFromTime));
        setWorkTimeTo(parseTime(Appointment.workToTime));
        setLunchTimeFrom(parseTime(Appointment.lunchFromTime));
        setLunchTimeTo(parseTime(Appointment.lunchToTime));

        setSelectedSelectWeekDays(selectedDays);
        setSelectedSelectTimeSlot(
            Array.isArray(Appointment.timeSlot)
                ? Appointment.timeSlot.map((slot) => options1.find((option) => option.value === slot))
                : options1.find((option) => option.value === Appointment.timeSlot)
        );

        setShowModal1(true);
    };

    const handleEditCustomWorkingTime = (Appointment) => {
        setCredentials1((prevCredentials) => ({
            ...prevCredentials,
            customTimingGuid: Appointment.customTimingGuid,
            appointmentType: Appointment.appointmentType,
            isDayOff: Appointment.isDayOff
        }));
        setShowModal1(true);
    }

    const handleSave = () => {
        if (activeTab === "default-working-time") {

            if (validate()) {
                dispatch(actionDoctor.saveDefaultTiming(credentials, (error, response) => {
                    if (error) {
                        if (error.data) {
                            if (error.data.statusCode === 400) {
                                if (error.data.error && error.data.error.ValidationErrors) {
                                    error.data.error.ValidationErrors.forEach((validationError) => {
                                        console.error(`${t("Field")}: ${validationError.Field} - ${t("Message")}: ${validationError.Message}`);

                                        showAlert("danger", validationError.Message, `${t("Error")} : ${validationError.Field}`);
                                    });
                                } else {
                                    showAlert("danger", t("Invalid_credentials"), `${t("Error")} !`);
                                }
                            } else {
                                showAlert("danger", t("unexpected_error"), `${t("Error")} !`);
                            }
                        }
                    } else if (response) {
                        if (response.status === 200) {
                            dispatch(actionDoctor.getDefaultTiming(loginData.userGuid, loginData.clinicGuid, false));
                            showToast(
                                `${t("success")}`,
                                t("doctor.My_Schedule.default_message"),
                                5000,
                                true,
                                "top-end toast-success"
                            );
                            setShowModal1(false);
                        }
                    }
                }))

            }
            setSelectedSelectWeekDays([])
        } else if (activeTab === "custom-working-time") {

            dispatch(actionDoctor.saveCustomTiming(credentials1, (error, response) => {
                if (error) {
                    if (error.data) {
                        if (error.data.statusCode === 400) {
                            if (error.data.error && error.data.error.ValidationErrors) {
                                error.data.error.ValidationErrors.forEach((validationError) => {
                                    console.error(`${t("Field")}: ${validationError.Field} - ${t("Message")}: ${validationError.Message}`);

                                    showAlert("danger", validationError.Message, `${t("Error")} : ${validationError.Field}`);
                                });
                            } else {
                                showAlert("danger", t("Invalid_credentials"), `${t("Error")} !`);
                            }
                        } else {
                            showAlert("danger", t("unexpected_error"), `${t("Error")} !`);
                        }
                    }
                } else if (response) {
                    if (response.status === 200) {
                        dispatch(actionDoctor.getCustomTiming(loginData.userGuid));
                        showToast(
                            `${t("success")}`,
                            t("doctor.My_Schedule.custom_message"),
                            5000,
                            true,
                            "top-end toast-success"
                        );

                        setShowModal1(false);
                        setworkDateFrom(null);
                        setworkDateTo(null);
                    }
                }
            }))


        }
    };

    const handleDeleteDefaultWorkingTime = (defaultTimingGuid) => {

        showModal({
            title: <h2 className="exado-title-nine">{t("visiting_schedule.delete_default_time")}</h2>,
            bodyContent: <TbInfoTriangleFilled className="info-triangle-icon" />,
            bodyContent1: (
                <p className="exado-title-six">
                    {" "}
                    {t("visiting_schedule.confirm_delete_default_time")}
                </p>
            ),
            // autoClose: 5000,
            footer: (
                <>
                    <Buttton.Buttton
                        children={t("CANCEL")}
                        className="btn-border-Aqua_Teal"
                        onClick={hideModal}
                    />
                    <Buttton.Buttton
                        children={t("delete")}
                        className="btn-solid-Carmine_red"
                        onClick={() => {
                            hideModal();

                            dispatch(
                                actionDoctor.deleteDefaultTimingById(
                                    defaultTimingGuid,
                                    (error, response) => {
                                        if (error) {
                                            if (error.data) {
                                                if (error.data.statusCode === 400) {
                                                    if (error.data.error && error.data.error.ValidationErrors) {
                                                        error.data.error.ValidationErrors.forEach(
                                                            (validationError) => {
                                                                console.error(
                                                                    `${t("Field")}: ${validationError.Field} - ${t(
                                                                        "Message"
                                                                    )}: ${validationError.Message}`
                                                                );

                                                                showAlert(
                                                                    "danger",
                                                                    validationError.Message,
                                                                    `${t("Error")} : ${validationError.Field}`
                                                                );
                                                            }
                                                        );
                                                    } else {
                                                        showAlert(
                                                            "danger",
                                                            `${t("Invalid_credentials")}`,
                                                            `${t("Error")} !`
                                                        );
                                                    }
                                                } else {
                                                    showAlert(
                                                        "danger",
                                                        `${t("unexpected_error")}``${t("Error")} !`
                                                    );
                                                }
                                            }
                                        } else if (response) {
                                            if (response.status === 200) {
                                                dispatch(actionDoctor.getDefaultTiming(loginData.userGuid, loginData.clinicGuid, false));
                                                showSnackBar(t("visiting_schedule.default_time_deleted"), "snackbar-success")
                                            }
                                        }
                                    }
                                )
                            );

                        }}
                    />
                </>
            ),
            className: "del-modal",
        });
    }

    const handleDeleteCustomWorkingTime = (customTimingGuid) => {
        showModal({
            title: <h2 className="exado-title-nine">{t("visiting_schedule.delete_custom_time")}</h2>,
            bodyContent: <TbInfoTriangleFilled className="info-triangle-icon" />,
            bodyContent1: (
                <p className="exado-title-six">
                    {" "}
                    {t("visiting_schedule.confirm_delete_custom_time")}
                </p>
            ),
            // autoClose: 5000,
            footer: (
                <>
                    <Buttton.Buttton
                        children={t("CANCEL")}
                        className="btn-border-Aqua_Teal"
                        onClick={hideModal}
                    />
                    <Buttton.Buttton
                        children={t("delete")}
                        className="btn-solid-Carmine_red"
                        onClick={() => {
                            hideModal();
                            dispatch(
                                actionDoctor.deleteCustomTimingById(
                                    customTimingGuid,
                                    (error, response) => {
                                        if (error) {
                                            if (error.data) {
                                                if (error.data.statusCode === 400) {
                                                    if (error.data.error && error.data.error.ValidationErrors) {
                                                        error.data.error.ValidationErrors.forEach(
                                                            (validationError) => {
                                                                console.error(
                                                                    `${t("Field")}: ${validationError.Field} - ${t(
                                                                        "Message"
                                                                    )}: ${validationError.Message}`
                                                                );

                                                                showAlert(
                                                                    "danger",
                                                                    validationError.Message,
                                                                    `${t("Error")} : ${validationError.Field}`
                                                                );
                                                            }
                                                        );
                                                    } else {
                                                        showAlert(
                                                            "danger",
                                                            `${t("Invalid_credentials")}`,
                                                            `${t("Error")} !`
                                                        );
                                                    }
                                                } else {
                                                    showAlert(
                                                        "danger",
                                                        `${t("unexpected_error")}``${t("Error")} !`
                                                    );
                                                }
                                            }
                                        } else if (response) {
                                            if (response.status === 200) {
                                                dispatch(actionDoctor.getCustomTiming(loginData.userGuid));
                                                showSnackBar(t("visiting_schedule.custom_time_deleted"), "snackbar-success")
                                            }
                                        }
                                    }
                                )
                            );

                        }}
                    />
                </>
            ),
            className: "del-modal",
        });
    }



    const [activeTab, setActiveTab] = useState(id || "default-working-time");
    const onTabChange = (tabId) => {
        setActiveTab(tabId);
        navigate(`/doctor/my-schedule/${tabId}`);
    };
    useEffect(() => {
        setActiveTab("default-working-time");
    }, []);

    const tabs = [
        {
            id: "default-working-time",
            label: t("visiting_schedule.default_working_time"),
            content: <DefaultWorkingTime onlineAppointments={onlineAppointments} offlineAppointments={offlineAppointments} handleDeleteDefaultWorkingTime={handleDeleteDefaultWorkingTime} handleEditDefaultWorkingTime={handleEditDefaultWorkingTime} />,
            disabled: false,
        },
        {
            id: "custom-working-time",
            label: t("visiting_schedule.custom_working_time"),
            content: <CustomWorkingTime customAppointments={customAppointments} className='custom-working-time-row' handleDeleteCustomWorkingTime={handleDeleteCustomWorkingTime} handleEditCustomWorkingTime={handleEditCustomWorkingTime} />,
            disabled: false,
        },
    ];
    const buttons = (
        <>
            <Buttton.Buttton
                className="btn-solid-Aqua_Teal"
                onClick={() => setShowModal1(true)}
                children={
                    activeTab === "default-working-time" ? (
                        t("visiting_schedule.setup_working_time")
                    ) : (
                        <>
                            <IoTimeOutline style={{ marginRight: "8px" }} />
                            {t("visiting_schedule.add_custom_time")}
                        </>
                    )
                }
            />
        </>
    );
    const rightSide = (
        <Container fluid className="exado-container1">
            <Row className="exado-row1">
                <Col>
                    <Header.HeadingPage
                        pageHeading={t("My_Schedule")}
                        buttons={buttons}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col>
                    <NavAndTabs.NavAndTabs
                        tabs={tabs}
                        activeTab={activeTab}
                        onTabChange={onTabChange}
                    />
                </Col>
            </Row>
        </Container>
    );

    useEffect(() => {
        const currentTab = location.pathname.split("/")[3];
        setActiveTab(currentTab || "default-working-time");
    }, [location.pathname]);
    return (
        <>
            <AppLayout.AppLayoutOne
                leftSide={<Sides.LeftSides loginData={loginData} />}
                rightSide={rightSide}
            />
            <Modaal.Modaal
                show={showModal1}
                onHide={handleCloseModal}
                centered="true"
                size="xl"
                title={
                    <h2 className="exado-title-nine">
                        {activeTab === "default-working-time"
                            ? t("visiting_schedule.setup_working_hours")
                            : t("visiting_schedule.add_custom_working_time")}
                    </h2>
                }
                bodyContent={
                    <Form className="my-scheduale-form">
                        {activeTab === "default-working-time" ? (
                            <>
                                <Row className="scheduale-row">
                                    <Form.Label className="exado-title-six">
                                        {t("visiting_schedule.select_appointment_type")}
                                    </Form.Label>
                                    <Col className="form-grp-radio-col" md={12}>
                                        <Inputs.CheckRadioInput
                                            type="radio"
                                            label={t("In-Clinic")}
                                            name="isOnlineAppointment"
                                            className="form-grp-radio"
                                            checked={credentials.isOnlineAppointment === false}
                                            onChange={() =>
                                                setCredentials({ ...credentials, isOnlineAppointment: false })
                                            }
                                        // disabled={!isEditVisible}
                                        />
                                        <Inputs.CheckRadioInput
                                            type="radio"
                                            label={t("Online")}
                                            name="isOnlineAppointment"
                                            className="form-grp-radio"
                                            checked={credentials.isOnlineAppointment === true}
                                            onChange={() =>
                                                setCredentials({ ...credentials, isOnlineAppointment: true })
                                            }
                                        // disabled={!isEditVisible}
                                        />
                                    </Col>
                                </Row>
                                <Row className="scheduale-row">
                                    <Col className="scheduale-col">
                                        <Form.Label className="exado-title-six">
                                            {t("enter_day")}
                                        </Form.Label>
                                        <SelectO.SelectO
                                            options={options}
                                            onChange={(selected) =>
                                                handleSelectWeekDays("days", selected)
                                            }
                                            isMulti={true}
                                            isSearchable={false}
                                            name="days"
                                            value={selectedSelectWeekDays || ""}
                                            className={`select1 ${errors.days ? "select-border-error" : ""
                                                }`}
                                            placeholder={t("Select") + " " + t("day")}
                                        // isDisabled={!isEditVisible}
                                        />
                                        {errors.days && (
                                            <Form.Text className="error-message noVerify">
                                                {errors.days}
                                            </Form.Text>
                                        )}
                                    </Col>
                                    <Col className="scheduale-col">
                                        <Form.Label className="exado-title-six">
                                            {t("visiting_schedule.consultation_duration")}
                                        </Form.Label>
                                        <SelectO.SelectO
                                            options={options1}
                                            onChange={handleSelectTimeSlot}
                                            // isMulti={true}
                                            // isSearchable={false}
                                            name="timeSlot"
                                            value={selectedSelectTimeSlot || ""}
                                            className={`select1 ${errors.timeSlot ? "select-border-error" : ""
                                                }`}
                                            placeholder={t("visiting_schedule.session_duration")}
                                        // isDisabled={!isEditVisible}
                                        />
                                        {errors.timeSlot && (
                                            <Form.Text className="error-message noVerify">
                                                {errors.timeSlot}
                                            </Form.Text>
                                        )}
                                    </Col>
                                </Row>
                                <Row className="scheduale-row">
                                    <Col className="scheduale-col">
                                        <Row>
                                            <Form.Label className="exado-title-six">
                                                {t("visiting_schedule.working_time_label")}
                                            </Form.Label>
                                            <Col md={4}>
                                                <fieldset className="frm-fieldset custom-date-picker custom-time-picker">
                                                    <legend className="frm-legend">{t("From")}</legend>
                                                    <CustomDatePicker.CustomTimePicker
                                                        selected={workTimeFrom}
                                                        onChange={(time) => handleTimeChange(time, "workFromTime")}

                                                        timeIntervals={15}
                                                        placeholderText="HH : MM "
                                                        className="customDatePicker customTimePicker"
                                                        timeCaption={t("From")}
                                                        // disabled={!isEditVisible}
                                                        showTimeSelect={true}
                                                        showTimeSelectOnly={true}
                                                    />
                                                </fieldset>
                                            </Col>
                                            <Col md={{ span: 4, offset: 1 }}>
                                                <fieldset className="frm-fieldset custom-date-picker custom-time-picker">
                                                    <legend className="frm-legend">{t("to")}</legend>
                                                    <CustomDatePicker.CustomTimePicker
                                                        selected={workTimeTo}
                                                        onChange={(time) => handleTimeChange(time, "workToTime")}

                                                        timeIntervals={15}
                                                        placeholderText="HH : MM"
                                                        className="customDatePicker customTimePicker"
                                                        timeCaption={t("to")}
                                                        // disabled={!isEditVisible}
                                                        showTimeSelect={true}
                                                        showTimeSelectOnly={true}
                                                    />
                                                </fieldset>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col className="scheduale-col">
                                        <Row>
                                            <Form.Label className="exado-title-six">
                                                {t("lunch_break")} ({t("Optional")})
                                            </Form.Label>
                                            <Col md={4}>
                                                <fieldset className="frm-fieldset custom-date-picker custom-time-picker">
                                                    <legend className="frm-legend">{t("From")}</legend>
                                                    <CustomDatePicker.CustomTimePicker
                                                        selected={lunchTimeFrom}
                                                        onChange={(time) => handleTimeChange(time, "lunchFromTime")}

                                                        timeIntervals={15}
                                                        placeholderText="HH : MM"
                                                        className="customDatePicker customTimePicker"
                                                        timeCaption={t("From")}
                                                        // disabled={!isEditVisible}
                                                        showTimeSelect={true}
                                                        showTimeSelectOnly={true}
                                                    />
                                                </fieldset>
                                            </Col>
                                            <Col md={{ span: 4, offset: 1 }} className="scheduale-col">
                                                <fieldset className="frm-fieldset custom-date-picker custom-time-picker">
                                                    <legend className="frm-legend">{t("to")}</legend>
                                                    <CustomDatePicker.CustomTimePicker
                                                        selected={lunchTimeTo}
                                                        onChange={(time) => handleTimeChange(time, "lunchToTime")}

                                                        timeIntervals={15}
                                                        placeholderText="HH : MM"
                                                        className="customDatePicker customTimePicker"
                                                        timeCaption={t("to")}
                                                        // disabled={!isEditVisible}
                                                        showTimeSelect={true}
                                                        showTimeSelectOnly={true}
                                                    />
                                                </fieldset>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>


                            </>
                        ) : (
                            <>
                                <Row className="scheduale-row">
                                    <Form.Label className="exado-title-six">
                                        {t("visiting_schedule.select_appointment_type")}
                                    </Form.Label>
                                    <Col className="form-grp-radio-col" md={12}>
                                        <Inputs.CheckRadioInput
                                            type="radio"
                                            label={t("In-Clinic")}
                                            name="appointmentType"
                                            className="form-grp-radio"
                                            checked={credentials1.appointmentType === 2}
                                            onChange={() =>
                                                setCredentials1({ ...credentials1, appointmentType: 2 })
                                            }
                                        // disabled={!isEditVisible}
                                        />
                                        <Inputs.CheckRadioInput
                                            type="radio"
                                            label={t("Online")}
                                            name="appointmentType"
                                            className="form-grp-radio"
                                            checked={credentials1.appointmentType === 1}
                                            onChange={() =>
                                                setCredentials1({ ...credentials1, appointmentType: 1 })
                                            }
                                        // disabled={!isEditVisible}
                                        />
                                        {credentials1.isDayOff && (
                                            <Inputs.CheckRadioInput
                                                type="radio"
                                                label={t("both")}
                                                name="appointmentType"
                                                className="form-grp-radio"
                                                checked={credentials1.appointmentType === 3}
                                                onChange={() =>
                                                    setCredentials1({ ...credentials1, appointmentType: 3 })
                                                }
                                            // disabled={!isEditVisible}
                                            />
                                        )}

                                    </Col>
                                </Row>
                                <Row className="scheduale-row">
                                    <Form.Label className="exado-title-six">
                                        {t("is_day_off")}
                                    </Form.Label>
                                    <Col md={12}>
                                        <Inputs.CheckRadioInput
                                            name="isDayOff"
                                            checked={credentials1.isDayOff}
                                            label="Yes"
                                            onChange={(e) => {
                                                const isChecked = e.target.checked;

                                                setCredentials1({
                                                    ...credentials1,
                                                    isDayOff: isChecked,
                                                    appointmentType: 1,
                                                    workFromTime: new Date().toISOString(),
                                                    workToTime: new Date().toISOString(),
                                                });
                                            }}
                                            className="form-grp-check"
                                        />
                                    </Col>
                                </Row>
                                <Row className="scheduale-row">
                                    <Form.Label className="exado-title-six">
                                        {t("Working Date")}
                                    </Form.Label>
                                    <Col md={12}>
                                        <Row>
                                            <Col md={4}>
                                                <fieldset className={`frm-fieldset custom-date-picker ${errors1.fromDate ? "error-date" : ""}`}>
                                                    <legend className="frm-legend">
                                                        {errors1.fromDate ? <span className="error-message">{errors1.fromDate}</span> : `${t("From")} ${t("date")}`}</legend>
                                                    <CustomDatePicker.CustomDatePickerDMY
                                                        selected={workDateFrom}
                                                        onChange={(date) => {
                                                            if (date) {
                                                                // Adjust the selected date to local timezone
                                                                const localDate = new Date(
                                                                    date.getTime() - date.getTimezoneOffset() * 60000
                                                                ).toISOString();

                                                                setCredentials1((prevCredentials) => ({
                                                                    ...prevCredentials,
                                                                    fromDate: localDate.split(".")[0] + ".000", // Store in "2024-12-31T18:30:00.000" format
                                                                }));
                                                                setworkDateFrom(date);
                                                                setErrors1((prevErrors) => ({ ...prevErrors, fromDate: "" })); // Clear errors
                                                            } else {
                                                                setCredentials1((prevCredentials) => ({
                                                                    ...prevCredentials,
                                                                    fromDate: "",
                                                                }));
                                                                setworkDateFrom(null);
                                                            }
                                                        }}
                                                        placeholderText="DD - MM - YYYY"
                                                        dateFormat="dd-MM-yyyy"
                                                        className="customDatePicker"
                                                    // disabled={!isEditVisible}
                                                    />
                                                </fieldset>
                                            </Col>
                                            <Col md={{ span: 4, offset: 1 }}>
                                                <fieldset className={`frm-fieldset custom-date-picker ${errors1.toDate ? "error-date" : ""}`}>
                                                    <legend className="frm-legend">{errors1.toDate ? (
                                                        <span className="error-message">{errors1.toDate}</span>
                                                    ) : (
                                                        `${t("to")} ${t("date")}`
                                                    )}</legend>
                                                    <CustomDatePicker.CustomDatePickerDMY
                                                        selected={workDateTo}
                                                        onChange={(date) => {
                                                            if (date) {
                                                                const localDate = new Date(
                                                                    date.getTime() - date.getTimezoneOffset() * 60000
                                                                ).toISOString();

                                                                setCredentials1((prevCredentials) => ({
                                                                    ...prevCredentials,
                                                                    toDate: localDate.split(".")[0] + ".000",
                                                                }));
                                                                setworkDateTo(date);
                                                                setErrors1((prevErrors) => ({ ...prevErrors, fromDate: "" }));
                                                            } else {
                                                                setCredentials1((prevCredentials) => ({
                                                                    ...prevCredentials,
                                                                    toDate: "",
                                                                }));
                                                                setworkDateTo(null);
                                                            }
                                                        }}
                                                        placeholderText="DD - MM - YYYY"
                                                        dateFormat="dd-MM-yyyy"
                                                        className="customDatePicker"
                                                    // disabled={!isEditVisible}
                                                    />
                                                </fieldset>
                                            </Col>
                                        </Row>


                                    </Col>

                                </Row>
                                {credentials1.isDayOff ? (
                                    <Row className="scheduale-row">
                                        <Form.Label className="exado-title-six">{t("in_perpetuity")}</Form.Label>
                                        <Col md={12}>
                                            <Inputs.CheckRadioInput
                                                name="isYearlyDayOff"
                                                checked={credentials1.isYearlyDayOff}
                                                label="Yes"
                                                onChange={(e) => {
                                                    const isChecked = e.target.checked;
                                                    setCredentials1({
                                                        ...credentials1,
                                                        isYearlyDayOff: isChecked
                                                    });
                                                }}
                                                className="form-grp-check"
                                            />
                                        </Col>
                                    </Row>
                                ) : (
                                    <Row className="scheduale-row">
                                        <Col className="scheduale-col">
                                            <Row>
                                                <Form.Label className="exado-title-six">
                                                    {t("visiting_schedule.working_time_label")}
                                                </Form.Label>
                                                <Col md={4}>
                                                    <fieldset className="frm-fieldset custom-date-picker custom-time-picker">
                                                        <legend className="frm-legend">{t("From")}</legend>
                                                        <CustomDatePicker.CustomTimePicker
                                                            selected={workTimeFrom1}
                                                            onChange={(time) => handleTimeChange1(time, "workFromTime")}
                                                            // timeFormat="hh:mm"
                                                            timeIntervals={15}
                                                            placeholderText="HH : MM"
                                                            className="customDatePicker customTimePicker"
                                                            timeCaption={t("From")}
                                                            // disabled={!isEditVisible}
                                                            showTimeSelect={true}
                                                            showTimeSelectOnly={true}
                                                        />
                                                    </fieldset>
                                                </Col>
                                                <Col md={{ span: 4, offset: 1 }}>
                                                    <fieldset className="frm-fieldset custom-date-picker custom-time-picker">
                                                        <legend className="frm-legend">{t("to")}</legend>
                                                        <CustomDatePicker.CustomTimePicker
                                                            selected={workTimeTo1}
                                                            onChange={(time) => handleTimeChange1(time, "workToTime")}
                                                            // timeFormat="hh:mm"
                                                            timeIntervals={15}
                                                            placeholderText="HH : MM"
                                                            className="customDatePicker customTimePicker"
                                                            timeCaption={t("to")}
                                                            // disabled={!isEditVisible}
                                                            showTimeSelect={true}
                                                            showTimeSelectOnly={true}
                                                        />
                                                    </fieldset>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col className="scheduale-col">
                                            <Row>
                                                <Form.Label className="exado-title-six">
                                                    {t("lunch_break")} ({t("Optional")})
                                                </Form.Label>
                                                <Col md={4}>
                                                    <fieldset className="frm-fieldset custom-date-picker custom-time-picker">
                                                        <legend className="frm-legend">{t("From")}</legend>
                                                        <CustomDatePicker.CustomTimePicker
                                                            selected={lunchTimeFrom1}
                                                            onChange={(time) => handleTimeChange1(time, "lunchFromTime")}

                                                            timeIntervals={15}
                                                            placeholderText="HH : MM"
                                                            className="customDatePicker customTimePicker"
                                                            timeCaption={t("From")}
                                                            // disabled={!isEditVisible}
                                                            showTimeSelect={true}
                                                            showTimeSelectOnly={true}
                                                        />
                                                    </fieldset>
                                                </Col>
                                                <Col md={{ span: 4, offset: 1 }} className="scheduale-col">
                                                    <fieldset className="frm-fieldset custom-date-picker custom-time-picker">
                                                        <legend className="frm-legend">{t("to")}</legend>
                                                        <CustomDatePicker.CustomTimePicker
                                                            selected={lunchTimeTo1}
                                                            onChange={(time) => handleTimeChange1(time, "lunchToTime")}
                                                            timeIntervals={15}
                                                            placeholderText="HH : MM"
                                                            className="customDatePicker customTimePicker"
                                                            timeCaption={t("to")}
                                                            // disabled={!isEditVisible}
                                                            showTimeSelect={true}
                                                            showTimeSelectOnly={true}
                                                        />
                                                    </fieldset>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                )}
                            </>
                        )}
                    </Form>
                }
                footer={
                    <>
                        <Buttton.Buttton
                            children={t("CANCEL")}
                            className="btn-border-Aqua_Teal"
                            onClick={handleCloseModal}
                        />
                        <Buttton.Buttton
                            children={t("save")}
                            className="btn-solid-Aqua_Teal"
                            onClick={handleSave}
                        />
                    </>
                }
                backdrop="static"
                className="input-modal"
            />
        </>
    );
};

export default MySchedule;
